







import { Component, Vue } from 'vue-property-decorator';
import Layer from '@/components/service/InsLayer.vue';
import { FrontE } from '@/sdk/common/SysConst';
@Component({
  components: {
    Layer
  }
})
export default class App extends Vue {
  lang:string[] = ['E', 'C', 'S'];

  beforeUpdate () {
    if (this.$route.query.returnUrl) {
      let url = this.$route.query.returnUrl + '?';
      Object.keys(this.$route.query).forEach((e) => {
        if (e !== 'returnUrl') url += e + '=' + this.$route.query[e] + '&';
      });
      this.$router.push(url);
    } else {
      this.$Api.promotion.GetHomeSeoData().then(result => {
        document.title = result.Data.Title;
      });
    }
  }

  mounted () {
    Vue.prototype.$ShowLayer();
    setTimeout(() => { Vue.prototype.$HiddenLayer(); }, 2000);
    // Api.getData(null, 10);
  }
  created () {
  //   this.$Api.member.setCurrency(1).then((result) => {
  //     this.$store.dispatch('setCurrency', result.ReturnValue);
  //   }).catch((error) => {
  //     console.log(error);
  //   });

    if (this.$Storage.get('isLogin')) {
      this.$Api.member.getProfile().then((data) => {
        this.$store.dispatch('setUser', (data.FirstName + ' ' + data.LastName).toUpperCase());
        this.$i18n.locale = this.lang[data.Language];
        this.$store.dispatch('setLang', this.lang[data.Language]);
        this.$Storage.set('locale', this.lang[data.Language]);
        this.$store.dispatch('setMemberInfo', data);
      });
    }
  }

  beforeCreate () {
    if (((Vue.prototype.userAgent === 'mobile' && FrontE.mobileBuilding) || (Vue.prototype.userAgent === 'pc' && FrontE.pcBuilding)) && (this.$route.name !== 'building')) {
      this.$router.push('/building');
    }
    if (!window['MemberApi']) window['MemberApi'] = this.$Api.member;
  }
}
